export default function ParseKeypointsToHTML(keypoints) {
    const keypointsElement = document.createElement("ul")
    keypoints.keypoints.forEach(element => {
        let li = document.createElement("li")
        li.textContent = element
        keypointsElement.appendChild(li)
    })
    return keypointsElement.outerHTML
}